import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Wifi, WifiOff, RefreshCw, Cloud, CloudOff } from 'lucide-react';
import { Button } from './ui/button';
import { useOfflineMode } from '../hooks/useOfflineMode';
import { toast } from 'sonner';

export default function OfflineStatusBar() {
  const { isOnline, pendingCount, isSyncing, syncData } = useOfflineMode();

  const handleSync = async () => {
    const result = await syncData();
    if (result.success) {
      toast.success(result.message);
    } else {
      toast.error(result.message);
    }
  };

  return (
    <AnimatePresence>
      {(!isOnline || pendingCount > 0) && (
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-50"
        >
          <div 
            className={`flex items-center justify-between px-4 py-2 ${
              isOnline ? 'bg-yellow-500/90' : 'bg-red-500/90'
            }`}
          >
            <div className="flex items-center gap-2 text-white">
              {isOnline ? (
                <>
                  <Cloud className="w-5 h-5" />
                  <span className="text-sm font-medium">
                    {pendingCount} action(s) en attente de synchronisation
                  </span>
                </>
              ) : (
                <>
                  <WifiOff className="w-5 h-5" />
                  <span className="text-sm font-medium">
                    Mode hors ligne - Les données seront synchronisées au retour du réseau
                  </span>
                </>
              )}
            </div>

            {isOnline && pendingCount > 0 && (
              <Button
                onClick={handleSync}
                disabled={isSyncing}
                size="sm"
                className="bg-white/20 hover:bg-white/30 text-white border-0"
              >
                <RefreshCw className={`w-4 h-4 mr-2 ${isSyncing ? 'animate-spin' : ''}`} />
                {isSyncing ? 'Sync...' : 'Synchroniser'}
              </Button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

// Mini badge pour afficher le statut dans un coin
export function OfflineStatusBadge() {
  const { isOnline, pendingCount } = useOfflineMode();

  if (isOnline && pendingCount === 0) return null;

  return (
    <div 
      className={`fixed bottom-4 right-4 z-50 flex items-center gap-2 px-3 py-2 rounded-full shadow-lg ${
        isOnline ? 'bg-yellow-500' : 'bg-red-500'
      } text-white text-sm font-medium`}
    >
      {isOnline ? (
        <>
          <CloudOff className="w-4 h-4" />
          <span>{pendingCount} en attente</span>
        </>
      ) : (
        <>
          <WifiOff className="w-4 h-4" />
          <span>Hors ligne</span>
        </>
      )}
    </div>
  );
}
